import { useState, useEffect } from 'react';
import { useTranslation } from '../i18n/LanguageContext.jsx';
import PasswordGate from '../components/PasswordGate.jsx';
import InterviewPage from './InterviewPage.jsx';

/**
 * InterviewRoute page — password-gated entry to the interview agent.
 *
 * Checks sessionStorage for existing auth. If authenticated, shows InterviewPage.
 * Otherwise renders PasswordGate for password verification.
 */
function InterviewRoute() {
  const { setLanguage } = useTranslation();
  const [authenticated, setAuthenticated] = useState(
    () => !!sessionStorage.getItem('interviewAuth')
  );

  useEffect(() => {
    const hasSetLang = sessionStorage.getItem('interviewLangSet');
    if (!hasSetLang) {
      setLanguage('en');
      sessionStorage.setItem('interviewLangSet', '1');
    }
  }, [setLanguage]);

  function handleAuth(token) {
    sessionStorage.setItem('interviewAuth', token);
    setAuthenticated(true);
  }

  return (
    <div className="App">
      {authenticated ? <InterviewPage /> : <PasswordGate onSuccess={handleAuth} />}
    </div>
  );
}

export default InterviewRoute;
